import { AlertTitle as ChakraAlertTitle } from '@chakra-ui/react';

type AlertTitleProps = React.ComponentProps<typeof ChakraAlertTitle>;

const AlertTitle = ({ children, ...props }: Readonly<AlertTitleProps>) => {
  return <ChakraAlertTitle {...props}>{children}</ChakraAlertTitle>;
};

export default AlertTitle;
